import type { AppBootstrap } from "@repo/shared/types";
import { ApiError, get } from "./_client";

/**
 * The app shell's bootstrap payload, or `null` when there is no session.
 * QL-628 — the web requests this in parallel with get-session on a cold load, so
 * "not logged in" is an ordinary outcome here, not a query error (which would be
 * logged and shipped to /internal/client-logs for every signed-out visit).
 */
export async function getAppBootstrap(): Promise<AppBootstrap | null> {
  try {
    return await get<AppBootstrap>("/internal/app-bootstrap");
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null;
    throw err;
  }
}
